<template>
    <div>
        <app-sub-title
            :text="'Contactos del cliente ' + theClient.name"
        ></app-sub-title>
        <b-button variant="primary" @click="startSaveContact"
            ><i class="fa fa-plus"></i> Crear contacto</b-button
        >
        <app-contacts-filters @filter="onFilter" :venues="venues" />
        <app-contacts-list
            :data="data"
            @change-page="changePage"
            @see-details-contact="seeDetails"
            @update-contact="startUpdate"
            @remove-contact="startRemove"
            @sort="onSort"
        />

        <!-- Inicio pop up's -->
        <app-pop-up title="Confirmación" id="contact-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar este contacto?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <b-button
                    variant="primary"
                    @click="deleteContact(selectContact)"
                    ><i class="fa fa-trash-o"></i> Confirmar
                    Eliminación</b-button
                >
            </div>
        </app-pop-up>

        <app-pop-up title="Vista detallada" id="see-contact" size="extra-large">
            <div slot="body">
                <b-card
                    v-if="selectContact"
                    title="Datos personales"
                    tag="article"
                    style="max-width: 100%;"
                    class="mb-2"
                >
                    <div class="card-text">
                        <b-row>
                            <b-col class="pb-3" cols="12" md="4">
                                <h5>Cliente</h5>
                                {{ client.name }}
                            </b-col>
                            <b-col class="pb-3" cols="12" md="4">
                                <h5>Sede</h5>
                                {{ selectContact.venue.name }}
                            </b-col>
                            <b-col class="pb-3" cols="12" md="4">
                                <h5>¿Contacto principal?</h5>
                                <div v-if="selectContact.main">Si</div>
                                <div v-else>No</div>
                            </b-col>
                            <b-col
                                class="pb-3"
                                cols="12"
                                md="4"
                                v-if="selectContact.position"
                            >
                                <h5>Rol</h5>
                                {{ selectContact.position }}
                            </b-col>
                            <b-col class="pb-3" cols="12" md="4">
                                <h5>Nombre</h5>
                                {{ selectContact.first_name }}
                            </b-col>
                            <b-col class="pb-3" cols="12" md="4">
                                <h5>Apellido</h5>
                                {{ selectContact.last_name }}
                            </b-col>
                            <b-col
                                class="pb-3"
                                cols="12"
                                md="4"
                                v-if="selectContact.birthdate"
                            >
                                <h5>Fecha de nacimiento</h5>
                                {{ selectContact.birthdate | date }}
                            </b-col>
                            <b-col
                                class="pb-3"
                                cols="12"
                                md="4"
                                v-if="selectContact.address"
                            >
                                <h5>Dirección</h5>
                                {{ selectContact.address }}
                            </b-col>
                            <b-col
                                class="pb-3"
                                cols="12"
                                md="4"
                                v-if="selectContact.email"
                            >
                                <h5>Email</h5>
                                {{ selectContact.email }}
                            </b-col>
                            <b-col
                                class="pb-3"
                                cols="12"
                                md="4"
                                v-if="selectContact.phone_primary"
                            >
                                <h5>Teléfono principal</h5>
                                {{ selectContact.phone_primary }}
                            </b-col>
                            <b-col
                                class="pb-3"
                                cols="12"
                                md="4"
                                v-if="selectContact.phone_secondary"
                            >
                                <h5>Teléfono secundario</h5>
                                {{ selectContact.phone_secondary }}
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
                <b-card
                    v-if="
                        selectContact && selectContact.contact_info_data.length
                    "
                    title="Datos detallados"
                    tag="article"
                    style="max-width: 100%;"
                    class="mb-2"
                >
                    <div class="card-text">
                        <b-row>
                            <b-col
                                class="pb-3"
                                cols="12"
                                md="4"
                                v-for="(contactInfoData,
                                i) in selectContact.contact_info_data"
                                :key="i"
                            >
                                <h5>
                                    {{ contactInfoData.contact_info_conf.name }}
                                </h5>
                                {{ contactInfoData.value }}
                            </b-col>
                        </b-row>
                    </div>
                </b-card>
            </div>
        </app-pop-up>
        <!-- Fin pop up's -->
    </div>
</template>

<script>
import ContactsList from './ContactsList/ContactsList.vue'
import ContactsFilters from './ContactsFilters/ContactsFilters.vue'
import contactsRepository from '../../../../repositories/contacts.repository.js'
import clientsRepository from '../../../../repositories/clients.repository.js'
export default {
    components: {
        appContactsList: ContactsList,
        appContactsFilters: ContactsFilters,
    },

    props: {
        theClient: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            data: {},
            filters: {},
            venues: [],
            page: 1,
            selectContact: '',
            sort: {
                sortBy: 'first_name',
                sortDir: 'asc',
            },
        }
    },
    methods: {
        loadContacts() {
            const cr = { ...contactsRepository }
            const filters = {
                ...this.filters,
                clientId: this.theClient.id,
                sortBy: this.sort.sortBy,
                sortDir: this.sort.sortDir,
            } //se cargan solo los contactos del cliente
            cr.getContacts(filters, this.page)
                .then(data => (this.data = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los contactos del cliente'
                    )
                )
        },
        loadVenues() {
            const cr = { ...clientsRepository }
            cr.getVenuesByClient(this.theClient.id)
                .then(data => (this.venues = data))
                .catch(error =>
                    toastr.error('Error al cargar las sedes del cliente')
                )
        },
        onFilter(filters) {
            this.filters = filters
            this.loadContacts()
        },
        changePage(page) {
            this.page = page
            this.loadContacts()
        },
        startSaveContact() {
            this.$router.push({
                name: 'contactForm',
                params: { clientId: this.theClient.id },
            })
        },
        seeDetails(contact) {
            this.selectContact = contact
            this.$bus.$emit('see-contact.open')
        },
        startUpdate(contact) {
            this.$router.push({
                name: 'contactForm',
                params: {
                    clientId: this.theClient.id,
                    contact: contact,
                    isSave: false,
                },
            })
        },
        startRemove(contact) {
            this.selectContact = contact
            this.$bus.$emit('contact-remove.open')
        },
        deleteContact(contact) {
            const cr = { ...contactsRepository }
            cr.deleteContact(contact.id)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        this.loadContacts()
                        this.$bus.$emit('contact-remove.close')
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error('No se pudo borrar el contacto')
                })
        },
        initialize() {
            this.loadContacts()
            this.loadVenues()
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy
            this.sort.sortDir = ctx.sortDir
            this.loadContacts()
        },
    },
    created() {
        this.initialize()
    },
}
</script>
